export default class LegacyEventService {

    static html = document.getElementsByTagName('html')[0];

    static dispatchEvent(eventName) {

        let event = document.createEvent('Event');
        event.initEvent(eventName, true, true);

        this.html.dispatchEvent(event);
    }

    static dispatchEventWithPayload(eventName, payload) {

        let event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, payload);

        this.html.dispatchEvent(event);
    }

    static addEventListener(type, listener) {
        document.addEventListener(type, listener);

    }

    static removeEventListener(type, listener) {
        document.removeEventListener(type, listener);
    }
}
